import { normalize } from 'normalizr';
import { mutation } from '@/dex-shared/helpers/graphql';
import { questionApplication } from '@/dex-shared/helpers/normalizr_schema';

export default {
  async PUSH_QUESTION_APPLICATION(
    { commit }: any,
    {
      questionId,
      examApplicationId,
    }: { questionId: number; examApplicationId: number },
  ) {
    const response = await mutation(
      `mutation dexAdminCreateQuestionApplication($questionId: Int!, $examApplicationId: Int!) {
      createQuestionApplication(input: {
        questionApplication: {
          questionId: $questionId
          examApplicationId: $examApplicationId
        }
      }) {
        questionApplication {
          id
          questionId
          examApplicationByExamApplicationId {
            id
            examTitle
            professionalTitle
            applicationYear
          }
        }
      }
    }`,
      {
        questionId,
        examApplicationId,
      },
    );
    const normalizedResponse = normalize(
      response.data.createQuestionApplication.questionApplication,
      questionApplication,
    );
    commit('SET_NORMALIZED_DATA', normalizedResponse.entities);
  },
  async REMOVE_QUESTION_APPLICATION(
    { commit }: any,
    questionApplicationId: number,
  ) {
    await mutation(
      `mutation dexAdminDeleteQuestionApplicationById($questionApplicationId: Int!) {
      deleteQuestionApplicationById(input: {
        id: $questionApplicationId
      }) {
        questionApplication {
          id
        }
      }
    }`,
      {
        questionApplicationId,
      },
    );
    commit('DELETE_ENTITY', {
      entity: 'question_applications',
      id: questionApplicationId,
    });
  },
};
